import palette from 'theme/palette'

const styles = () => ({
  inactivateReasonBox: {
    backgroundColor: palette.primary.light,
  },
})

export default styles
